import IndividualResultsPreview from "../../individual-results/pages/IndividualResultsPreview";
import useSurvey from "../../survey/hooks/useSurvey";
import { useTeam } from "../../TeamcompositeResults/contexts/TeamContext";
import ActivityLog from "./ActivityLog";
import CongratsBanner from "./CongratsBanner";
import Introduction from "./Introduction";
import WelcomeBack from "./WelcomeBack";
import TeamResultsSectionLoading from "./components/TeamResultsSectionLoading";
import TeamResultsPreview from "../../individual-results/pages/TeamResultsPreview";
import { useProfile } from "../../auth/hooks/useProfile";
import { RoleCode } from "../../../lib/rbac/role.constants";

const UserDashboard = () => {
  const { isCompleted, inProgress, notStarted, completionPercentage } =
    useSurvey();
  const { highestRole } = useProfile();

  const { hasTeamCompletionProgress, teamSurveyLoading } = useTeam();
  const showIndividual = isCompleted;
  const canShowTeamSection =
    hasTeamCompletionProgress && highestRole !== RoleCode.USER;

  return (
    <div className="flex flex-col gap-5">
      {/* Top Section */}
      <div className="flex flex-col desktop:flex-row gap-5 items-stretch">
        <div className="flex-1 min-w-0">
          {notStarted && <Introduction />}

          {isCompleted && <CongratsBanner />}

          {inProgress && (
            <WelcomeBack percent={Number(completionPercentage ?? 0)} />
          )}
        </div>

        <div className="w-full desktop:w-[300px] desktop:flex-shrink-0 desktop:max-h-[314px]">
          <ActivityLog />
        </div>
      </div>

      {/* Bottom Section - Full Width */}
      <div
        className={`grid gap-5 w-full ${
          showIndividual && canShowTeamSection
            ? "grid-cols-1 desktop:grid-cols-2"
            : "grid-cols-1"
        }`}
      >
        {showIndividual && <IndividualResultsPreview />}

        {canShowTeamSection &&
          (teamSurveyLoading ? (
            <TeamResultsSectionLoading />
          ) : (
            <TeamResultsPreview />
          ))}
      </div>
    </div>
  );
};
export default UserDashboard;
